import { useEffect, useRef } from "react";
import "altcha";
import "altcha/i18n/es-419";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Widget anti-bot ALTCHA (Proof-of-Work, self-hosted, sin tracking).
 * El usuario marca manualmente la casilla "No soy un robot" para resolver el challenge.
 * Idioma: español latinoamericano (es-419).
 */
export default function AltchaWidget({ onVerified, onExpired, testid = "altcha-widget" }) {
  const widgetRef = useRef(null);

  useEffect(() => {
    const el = widgetRef.current;
    if (!el) return;

    const handleStateChange = (ev) => {
      const state = ev?.detail?.state;
      const payload = ev?.detail?.payload;
      if (state === "verified" && payload && onVerified) {
        onVerified(payload);
      }
      if (state === "expired" && onExpired) {
        onExpired();
      }
    };

    el.addEventListener("statechange", handleStateChange);
    return () => el.removeEventListener("statechange", handleStateChange);
  }, [onVerified, onExpired]);

  return (
    <div data-testid={testid} className="altcha-wrap">
      <altcha-widget
        ref={widgetRef}
        challenge={`${BACKEND_URL}/api/altcha/challenge`}
        language="es-419"
      />
    </div>
  );
}
